import { combineReducers } from "redux";

const defaultCompanyFilter = {};
const companyFilter = (state = defaultCompanyFilter, action) => {
  if (action.type === "PROPOSALS_COMPANY_FILTER") {
    return action.filter;
  }
  return state;
};


const defaultGetProposals = false;
const getProposals = (state = defaultGetProposals, action) => {
  switch (action.type) {

    case "GET_PROPOSALS":
    case "GET_PROPOSALS_BY_COMPANY":
    case "GET_PROPOSAL_BY_ID":
    case "UPDATE_PROPOSAL":
    case "GET_PROPOSAL_BY_ID":
    case "GET_PROPOSALS_BY_ID"://ADD SPINNER
      return true;
    // ...Here should be one more case for SUCCESS
    case "GET_PROPOSALS_BY_ID_SUCCESS":
    case "GET_PROPOSALS_SUCCESS":
    case "GET_PROPOSAL_BY_ID_SUCCESS":
    case "UPDATE_PROPOSAL_SUCCESS":
    case "UPDATE_PROPOSAL_ERROR":
    case "GET_PROPOSALS_ERROR":
    case "GET_PROPOSALS_BY_COMPANY_ERROR":
    case "GET_PROPOSAL_BY_ID_ERROR":
    case "GET_PROPOSALS_BY_ID_ERROR":
      return false; // ADD ERROR HANDLING
    default:
      return state;
  }
};


const defaultDeleteProposalShow = false;
const deleteProposalShow = (state = defaultDeleteProposalShow, action) => {
  switch (action.type) {
    case 'DELETE_PROPOSAL_SHOW':
      return true;
    case 'DELETE_PROPOSAL_CANCEL':
    case 'DELETE_PROPOSAL_SUCCESS':
    case 'DELETE_PROPOSAL_FAILURE':
      return false;
    default:
      return state;
  }
};

const defaultDeleteProposalyID = null;
const deleteProposalID = (state = defaultDeleteProposalyID, action) => {
  switch (action.type) {
    case 'DELETE_PROPOSAL_SHOW':
      return action.id;
    case 'DELETE_PROPOSAL_SUCCESS':
    case 'DELETE_PROPOSAL_CANCEL':
      return null;
    default:
      return state;
  }
};

const defaultDowloadProposal = false;
const downloadProposal = (state = defaultDowloadProposal, action) => {
  switch (action.type) {
    case 'DOWNLOAD_PROPOSAL':
      return action.uuid;
    case 'DOWNLOAD_PROPOSAL_SUCCESS':
    case 'DOWNLOAD_PROPOSAL_FAILURE':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  companyFilter,
  deleteProposalShow,
  getProposals,
  deleteProposalID,
  downloadProposal
});
